import { FunctionComponent, useState } from 'react';
import { Box, IconCaretDown } from '@screentone/core';

import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import PageParametersForm from './components';
import styles from '../artifact-settings.module.scss';

interface ArtifactSettingsProps {
  isReadOnly?: boolean;
}

const ArtifactSettings: FunctionComponent<ArtifactSettingsProps> = ({ isReadOnly = false }) => {
  const { getSectionAttributes, setSectionAttributes, getDTO, metadata, setNewMetadata } = useDataModelContext();
  const [expanded, setExpanded] = useState(false);
  const dto = getDTO(true);
  const {
    metadata: { publicationKey }
  } = dto;

  const sectionAttributes = getSectionAttributes();

  return (
    <Box>
      <form id="page-parameters">
        <Box.Title
          onClick={() => {
            setExpanded((prevValue) => !prevValue);
          }}
          className={styles.collapsibleWrapper}
          variant="header3"
        >
          Section Parameters <IconCaretDown />
        </Box.Title>
        <Box.Content style={{ display: expanded ? 'block' : 'none' }}>
          <PageParametersForm
            metadataInitial={metadata}
            sectionAttributesInitial={sectionAttributes}
            publicationKey={publicationKey}
            actions={{
              update: (info) => {
                setSectionAttributes(info.sectionAttributes);
                setNewMetadata(info.metadata);
              }
            }}
            isReadOnly={isReadOnly}
          />
        </Box.Content>
      </form>
    </Box>
  );
};

export default ArtifactSettings;
